module.exports = __webpack_public_path__ + "img/DB4-1920_03.158619e3.jpg";